import React from "react"
import PropTypes from "prop-types"
import { AEM_ASSETS } from "components/Stacker/AEMConstants"

export function PreviousArrow(props) {
  const { className, onClick } = props
  return (
    <button className={className} onClick={onClick}>
      <img
        src={`${AEM_ASSETS}/icons/icon-left-arrow.png`}
        alt="Previous necklace"
      />
    </button>
  )
}

PreviousArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export function NextArrow(props) {
  const { className, onClick } = props
  return (
    <button className={className} onClick={onClick}>
      <img
        src={`${AEM_ASSETS}/icons/icon-right-arrow.png`}
        alt="Next necklace"
      />
    </button>
  )
}

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}
